import { legacyColors } from './colors.legacy';
import { newUiColors } from './colors.new-ui';
import { isNewUi } from './ui-version';

export const colors = isNewUi ? newUiColors : legacyColors;
